import type { FC } from 'react';
import { Loader } from 'lucide-react';

import { cn } from '@/lib/utils';

interface SpinnerProps {
  className?: string;
}
export const Spinner: FC<SpinnerProps> = ({ className }) => (
  <Loader className={cn('animate-spin', className)} />
);
